<script lang="ts">
import type { Message, Message as SmartsuppMessage } from '@smartsupp/smartsupp-message'
import { getContext } from 'svelte'

import { contentListItemKey, hasQuickReplies, type QuickReply, type WritableMessageContext } from '@/modules/messages'

import BotMessageReply from './BotMessageReply.svelte'

let context = $derived(getContext<WritableMessageContext>(contentListItemKey))
let message = $derived($context.message as SmartsuppMessage.Message)

let replies: QuickReply[] = $state([])
let goBackButtons: QuickReply[] = $state([])

let hasReplies = $derived(hasQuickReplies(message as Message.Message.Bot))

$effect(() => {
	if (message.content.quickReplies) {
		replies = message.content.quickReplies.filter(
			(r) => !(r.payload as QuickReply['payload']).isGoBackButton,
		) as QuickReply[] // TODO: fix type
		goBackButtons = message.content.quickReplies.filter(
			(r) => (r.payload as QuickReply['payload']).isGoBackButton,
		) as QuickReply[] // TODO: fix type
	}
})

let { id } = $derived(message)
</script>

{#if hasReplies}
	{#if replies.length > 0}
		<div class="flex flex-wrap justify-end">
			{#each replies as reply, index (reply.payload.replyId || index)}
				<BotMessageReply messageId={id} {reply} {index} />
			{/each}
		</div>
	{/if}
	{#if goBackButtons.length > 0}
		<div class="flex flex-wrap justify-end mt-2">
			{#each goBackButtons as reply}
				<BotMessageReply messageId={id} {reply} index={replies.length} />
			{/each}
		</div>
	{/if}
{/if}
